var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 17.3337C18.209 17.3337 19.9998 15.5428 19.9998 13.3337C19.9998 11.1245 18.209 9.33366 15.9998 9.33366C13.7907 9.33366 11.9998 11.1245 11.9998 13.3337M15.7497 21.7503H16.2497M15.7497 22.2503H16.2497M29.3332 16.0003C29.3332 23.3641 23.3636 29.3337 15.9998 29.3337C8.63604 29.3337 2.6665 23.3641 2.6665 16.0003C2.6665 8.63653 8.63604 2.66699 15.9998 2.66699C23.3636 2.66699 29.3332 8.63653 29.3332 16.0003ZM16.6665 22.0003C16.6665 22.3685 16.368 22.667 15.9998 22.667C15.6316 22.667 15.3332 22.3685 15.3332 22.0003C15.3332 21.6321 15.6316 21.3337 15.9998 21.3337C16.368 21.3337 16.6665 21.6321 16.6665 22.0003Z",
    stroke: "#7F56D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclequest);
export default __webpack_public_path__ + "static/media/circlequest.7e1135ed64047b7f146662318e17416b.svg";
export { ForwardRef as ReactComponent };